import "./styles/app.scss";
import Main from "./pages/main";
import History from "./pages/history";
import Steps from "./pages/steps";
import {Routes , Route} from "react-router-dom";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Main/>}/>
      <Route path="/historia" element={<History/>}/>
      <Route path="/etapas" element={<Steps/>}/>
    </Routes>
  );
};

export default App;